import React, { useEffect, useState } from 'react'

import PlayCircleFilledRounded from '@mui/icons-material/PlayCircleFilledRounded'
import CheckRounded from '@mui/icons-material/CheckRounded'
import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { generateVideoThumbnailViaUrl } from '@rajesh896/video-thumbnails-generator'

import ImageComponent from '../ImageComponent'
import { EventMedia } from '../../types'

interface IProps {
  item: EventMedia
  handleClick: (item: any, thumbnail: string | undefined) => void
  width: number
  selected?: EventMedia
}

const MediaListItem: React.FC<IProps> = ({ item, handleClick, width, selected }) => {
  const useStyles = makeStyles((theme: Theme) => ({
    imageContainer: {
      position: 'relative',
      margin: '2.5px',
      height: '105px',
      width: width || '105px',
      '&:hover': {
        cursor: 'pointer',
      },
      '&:hover > $overlay': {
        opacity: '0.64',
      },
    },
    checked: {
      '& $overlay': {
        opacity: '0.64',
      },
      '& $iconBlock': {
        opacity: 1,
      },
    },
    image: {
      position: 'relative',
      objectFit: 'cover',
      height: '105px',
      width: width || '105px',
      zIndex: 0,
    },
    overlay: {
      position: 'absolute',
      display: 'block',
      height: '105px',
      width: width || '105px',
      top: 0,
      left: 0,
      background: '#000000 0% 0% no-repeat padding-box',
      opacity: 0,
      zIndex: 1,
    },
    iconBlock: {
      position: 'absolute',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '105px',
      width: width || '105px',
      opacity: 0,
      top: 0,
      left: 0,
      zIndex: 2,
    },
    videoNoImage: {
      position: 'absolute',
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'flex-start',
      height: '105px',
      width: width || '105px',
      top: 0,
      left: 0,
      zIndex: 2,
      '& svg': {
        margin: '8px',
      },
    },
    animated: {
      animation: '$scale .5s ease-in-out  alternate',
    },
    '@keyframes scale': {
      '0%': {
        opacity: 0,
        transform: 'scale(1.0)',
      },
      '50%': {
        opacity: 1,
        transform: 'scale(1.2)',
      },
      '100%': {
        opacity: 1,
        transform: 'scale(1.0)',
      },
    },
  }))
  const classes = useStyles()
  const [videoThumbnail, setVideoThumbnail] = useState<string>()

  const isVideo = !!item.mimeType.match('video.*')

  useEffect(() => {
    isVideo && generateVideoThumbnailViaUrl(item.mediaUrl, 2).then((value) => {
      setVideoThumbnail(value)
    })
  }, [])

  return (
    <div
      className={`${classes.imageContainer}`}
      onClick={() => handleClick(item, videoThumbnail && videoThumbnail)}
    >
      <ImageComponent
        src={isVideo && videoThumbnail ? videoThumbnail : item.mediaUrl}
        fallback='/src/shared/assets/images/icon-img-placeholder.svg' className={classes.image}
      />

      {isVideo ? (
        <div className={classes.videoNoImage}>
          <PlayCircleFilledRounded
            style={{ color: '#fff', filter: 'drop-shadow( 0px 0px 3px rgba(0, 0, 0, .15))' }}
          />
        </div>
      ) : ''}

      <div className={classes.overlay} />
      <div className={classes.iconBlock}>
        <CheckRounded
          className={`${selected && item.mediaUrl === selected.mediaUrl ? classes.animated : ''}`}
          style={{ color: '#fff' }}
        />
      </div>
    </div>
  )
}
export default MediaListItem
